export default {
  saasTechSupport: {
    success: ['active'],
    info: ['cancelled', 'closed', 'refunded'],
    danger: ['failed'],
    warning: ['pending', 'request_refund'],
  },
  wecomExtGroups: {
    info: ['init'],
    success: ['ready'],
    danger: ['allocated'],
  },
}
